import React from 'react';

import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';

import CreateHomeView from '../Views/TO/Register/Local/CreateHomeView';
import {parseURL, parseCookies, isValidGoToURL} from "account-portal-library/lib/helperFunctions";
import CreateUserForm from './Local/CreateUserForm.js';
import UserExists from './UserExists'
import RegisterComplete from './RegisterComplete'
import { withGotoUrl } from '../../withGotoUrl.js';


class RegisterForm extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
            loginURI: "/",
            showForm: "CREATE",
            step: "account",
            email: "",
            style: "DG",
            isEmailAvailable: null,
            isResponseValid: null
        };
        this.setEmail = this.setEmail.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.hideModalUsername = this.hideModalUsername.bind(this);
        this.hideModalError = this.hideModalError.bind(this);
        this.setEmailAvailable = this.setEmailAvailable.bind(this);
        this.setResponseValid = this.setResponseValid.bind(this);
    }

    componentDidMount(){
        const parsedCookies = parseCookies(document.cookie);
        const url = window.location.search;
        const urlParams = parseURL(url); 

        sessionStorage.AP_STYLE = "DG"
        
        const isValidToyotaGoToURL = (value) => value && (isValidGoToURL('T', value) || isValidGoToURL('S', value));
        
        let loginURI = undefined;
        if (isValidToyotaGoToURL(parsedCookies["login_uri"])) {
            loginURI = parsedCookies["login_uri"];
        } else if (isValidToyotaGoToURL(parsedCookies["goto"])) {
            loginURI = parsedCookies["goto"];
        } else if (Object.keys(urlParams).includes("goto") && (isValidGoToURL('T', urlParams["goto"]) || isValidGoToURL('S', urlParams["goto"]))){
            loginURI = urlParams["goto"];
        }
        this.setState({loginURI: loginURI})
    }

    setEmail(value) {
        this.setState({email: value});

    }

    displayForm(value) {
        this.setState({showForm: value});
    }

    hideModalUsername(value){
        this.setState({isEmailAvailable: null})
      }
    
      setEmailAvailable(value){
        this.setState({isEmailAvailable: value})
      }
    
      hideModalError(value){
        this.setState({isResponseValid: null})
      }
    
      setResponseValid(value){
        this.setState({isResponseValid: value})
      }

    
    render(){
        if(this.state.showForm === "CREATE"){
            return(
            <CreateHomeView
            email = {this.state.email}
            hideModalUsername = {this.hideModalUsername}
            setEmailAvailable = {this.setEmailAvailable}
            hideModalError = {this.hideModalError}
            setResponseValid = {this.setResponseValid}
            isResponseValid = {this.state.isResponseValid}
            isEmailAvailable = {this.state.isEmailAvailable}
            setEmail = {this.setEmail}
            displayForm = {this.displayForm}
            style = "DG"
            />
            );
        }else if (this.state.showForm === "PASSWORD"){
            return(
                <CreateUserForm 
                email = {this.state.email}
                displayForm = {this.displayForm}
                style = "DG"
                loginURI = {this.state.loginURI}/>
            )
        } else if(this.state.showForm === "EXISTS"){
            return(
                <UserExists email = {this.state.email}
                style = "DG"/>
            )
        } else if (this.state.showForm === "COMPLETE"){
            return(
                <RegisterComplete email = {this.state.email}
                style = "DG"/>
            )
        }

    }

}

export default withGotoUrl(RegisterForm, ["T", "S"]);
